import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IClosedDealNotesResponseDto } from '../book.dto';

export const useClosedDealNotes = (author: string) => {
  const {
    book: { getClosedDealNotes }
  } = useServices();

  const res = useQuery<IClosedDealNotesResponseDto>(
    ['get-closed-deal-notes', author],
    () => getClosedDealNotes(author),
    {
      enabled: Boolean(author)
    }
  );

  return {
    data: res.data,
    isError: res.isError,
    isLoading: res.isLoading
  };
};